import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UTILS } from 'src/app/entities/Utils';

export interface ItemMultiSelect{
  value: string,
  label: string,
  selected? : boolean,
}

interface ConfigMultiSelect{
  select: boolean,
  element: ItemMultiSelect
}

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.css']
})
export class MultiSelectComponent implements OnInit, OnChanges {

  @Output() selectedItems : EventEmitter<string[]> = new EventEmitter();

  @Input() items : ItemMultiSelect[] | undefined;


  configMultiSelect : ConfigMultiSelect[] = [];

  open: boolean = false;

  selectedItemsArray : string[] = [];

  constructor() { }

  ngOnInit(): void {
    if(this.items){
      this.generateConfigMultiSelect();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.items){
      this.items = changes.items.currentValue;
      this.generateConfigMultiSelect();
    }
  }

  private generateConfigMultiSelect(){
    this.configMultiSelect = [];
    this.items!.forEach(e => {
      this.configMultiSelect.push({select: e.selected? e.selected:false,element: new UTILS().deepCopy(e)});
    });
    this.items!.filter(e => e.selected==true).forEach(e=> this.selectedItemsArray.push(e.value));
  }
}